import LoadingComponent from '../components/Loading';
import { trackedLazy, TrackedSuspense } from '../lib/tracked-lazy';

import { ErrorBoundary } from './ErrorBoundary';

function universal(load, page) {
  const Cmp = trackedLazy(load);
  return (props) => (
    <ErrorBoundary page={page}>
      <TrackedSuspense fallback={<LoadingComponent />}>
        <Cmp {...props} />
      </TrackedSuspense>
    </ErrorBoundary>
  );
}

export const ClaimSpot = universal(() => import('./ClaimSpot'), 'ClaimSpot');
export const CompletePayoutRequest = universal(
  () => import('./CompletePayoutRequest'),
  'CompletePayoutRequest'
);
export const DeleteAccount = universal(
  () => import('./DeleteAccount'),
  'DeleteAccount'
);
export const ForgotPassword = universal(
  () => import('./ForgotPassword'),
  'ForgotPassword'
);
export const TextClub = universal(() => import('./TextClub'), 'TextClub');
export const FullSignup = universal(() => import('./FullSignup'), 'FullSignup');
export const GameHostFeed = universal(
  () => import('./GameHostFeed'),
  'GameHostFeed'
);
export const GameSettings = universal(
  () => import('./GameSettings'),
  'GameSettings'
);
export const GlpWonJoin = universal(() => import('./GlpWonJoin'), 'GlpWonJoin');
export const GlpWonLogin = universal(
  () => import('./GlpWonLogin'),
  'GlpWonLogin'
);
export const GlpWonPay = universal(() => import('./GlpWonPay'), 'GlpWonPay');
export const GlpWonSignup = universal(
  () => import('./GlpWonSignup'),
  'GlpWonSignup'
);
export const GlpWonSmsConsent = universal(
  () => import('./GlpWonSmsConsent'),
  'GlpWonSmsConsent'
);
export const GlpWonSuccess = universal(
  () => import('./GlpWonSuccess'),
  'GlpWonSuccess'
);
export const InviteAccountabilityLanding = universal(
  () => import('./InviteAccountabilityLanding'),
  'InviteAccountabilityLanding'
);
export const InviteLanding = universal(
  () => import('./InviteLanding'),
  'InviteLanding'
);
export const Loading = universal(() => import('./Loading'), 'Loading');
export const Login = universal(() => import('./Login'), 'Login');
export const MembershipSignup = universal(
  () => import('./MembershipSignup'),
  'MembershipSignup'
);
export const ReferralSignup = universal(
  () => import('./ReferralSignup'),
  'ReferralSignup'
);
export const ResetPassword = universal(
  () => import('./ResetPassword'),
  'ResetPassword'
);
export const RoutinesGameLanding = universal(
  () => import('./RoutinesGameLanding'),
  'RoutinesGameLanding'
);
export const Signup = universal(() => import('./Signup'), 'Signup');
export const StartGameOrder = universal(
  () => import('./StartGameOrder'),
  'StartGameOrder'
);
export const StartGameBetOrder = universal(
  () => import('./StartGameBetOrder'),
  'StartGameBetOrder'
);
export const StartMembershipOrder = universal(
  () => import('./StartMembershipOrder'),
  'StartMembershipOrder'
);
export const StartOrder = universal(() => import('./StartOrder'), 'StartOrder');
export const OptionalBet = universal(
  () => import('./OptionalBet'),
  'OptionalBet'
);
export const PhoneNumber = universal(
  () => import('./PhoneNumber'),
  'PhoneNumber'
);
